import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

interface Props {
  title?: string;
  eyebrow?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function Section({ title, eyebrow, action, children, className }: Props) {
  return (
    <section className={cn("py-6", className)}>
      {(title || eyebrow || action) && (
        <header className="mb-3 flex items-end justify-between gap-3">
          <div>
            {eyebrow ? <div className="label-eyebrow mb-1">{eyebrow}</div> : null}
            {title ? <h2 className="font-serif text-xl text-ink">{title}</h2> : null}
          </div>
          {action ? <div className="shrink-0">{action}</div> : null}
        </header>
      )}
      {children}
    </section>
  );
}
